import { render, staticRenderFns } from "./cabinetView.vue?vue&type=template&id=09cc3820&"
import script from "./cabinetView.vue?vue&type=script&lang=js&"
export * from "./cabinetView.vue?vue&type=script&lang=js&"
import style0 from "./cabinetView.vue?vue&type=style&index=0&id=09cc3820&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports